import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

interface ExternalAdminResponse {
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  constructor(private httpClient: HttpClient) {}

  createExternalAdminURL(): Observable<string> {
    return this.httpClient
      .post<ExternalAdminResponse>(
        `${environment.apps.kanga}/api/v1/payments/subscriptions/external-admin`,
        {}
      )
      .pipe(map((response) => response.url));
  }
}
